import React, { useState, useEffect } from "react";

export default function Preloader() {
  const [progress, setProgress] = useState(0);
  const [statusText, setStatusText] = useState("Inițializare sistem...");
  const [hidden, setHidden] = useState(false);
  const [fade, setFade] = useState(false);

  const word1 = "INDUNGI";
  const word2 = "ROMÂNIA";

  useEffect(() => {
    const statuses = [
      { pct: 20, text: "Conectare la rețeaua INDUNGI..." },
      { pct: 48, text: "Sincronizare noduri live & servere..." },
      { pct: 76, text: "Încărcare profil & securitate..." },
      { pct: 95, text: "Pregătire experiență..." },
      { pct: 100, text: "Bine ai venit!" }
    ];

    let currentStep = 0;
    const interval = setInterval(() => {
      if (currentStep < statuses.length) {
        setProgress(statuses[currentStep].pct);
        setStatusText(statuses[currentStep].text);
        currentStep++;
      } else {
        clearInterval(interval);
        setTimeout(() => setFade(true), 250);
        setTimeout(() => setHidden(true), 800);
      }
    }, 160);

    return () => clearInterval(interval);
  }, []);

  if (hidden) return null;

  return (
    <div
      className={`fixed inset-0 z-[999999] bg-[#05070d]/85 backdrop-blur-xl flex flex-col items-center justify-center select-none transition-all duration-700 ${
        fade ? "opacity-0 pointer-events-none scale-105" : "opacity-100 scale-100"
      }`}
      data-testid="indunji-preloader"
    >
      {/* Subtle scanline and grid overlay */}
      <div 
        className="absolute inset-0 pointer-events-none opacity-20"
        style={{
          backgroundImage: "linear-gradient(rgba(255, 255, 255, 0.05) 1px, transparent 1px), linear-gradient(90deg, rgba(255, 255, 255, 0.05) 1px, transparent 1px)",
          backgroundSize: "32px 32px"
        }}
      />

      <div className="relative z-10 flex flex-col items-center max-w-lg px-6 text-center space-y-6">
        
        {/* Animated Glowing Text Title */}
        <div className="flex flex-col items-center space-y-3">
          {/* Main Kinetic Typography */}
          <div className="flex items-center justify-center gap-3 sm:gap-4 font-chakra font-black text-3xl sm:text-5xl lg:text-6xl tracking-wider uppercase">
            {/* INDUNGI */}
            <div className="flex items-center">
              {word1.split("").map((letter, i) => (
                <span
                  key={i}
                  className="inline-block transition-all duration-300 text-white"
                  style={{
                    animation: `idgPulseGlow 1.8s ease-in-out infinite`,
                    animationDelay: `${i * 0.1}s`,
                    textShadow: "0 0 20px rgba(255, 79, 0, 0.85), 0 0 40px rgba(255, 79, 0, 0.45)"
                  }}
                >
                  {letter}
                </span>
              ))}
            </div>

            {/* ROMÂNIA */}
            <div className="flex items-center">
              {word2.split("").map((letter, i) => (
                <span
                  key={i}
                  className="inline-block transition-all duration-300 text-transparent bg-clip-text bg-gradient-to-r from-[#FF4F00] via-amber-400 to-[#00ff88]"
                  style={{
                    animation: `idgPulseGlow 1.8s ease-in-out infinite`,
                    animationDelay: `${(i + word1.length) * 0.1}s`,
                    filter: "drop-shadow(0 0 15px rgba(0, 255, 136, 0.75))"
                  }}
                >
                  {letter}
                </span>
              ))}
            </div>
          </div>

          {/* Subtitle with pulsing dot */}
          <div className="flex items-center gap-2 text-[10px] sm:text-[11px] font-mono uppercase tracking-[0.3em] text-zinc-300">
            <span className="w-1.5 h-1.5 rounded-full bg-[#FF4F00] animate-ping" />
            <span>ESPORTS & GAMING COMMUNITY · EST. 2010</span>
          </div>
        </div>

        {/* Tactical Progress Bar */}
        <div className="w-64 sm:w-80 space-y-2 pt-2">
          <div className="w-full h-2 bg-black/60 rounded-full overflow-hidden p-0.5 border border-white/15 backdrop-blur-md shadow-inner relative">
            <div 
              className="h-full rounded-full bg-gradient-to-r from-[#FF4F00] via-amber-400 to-[#00ff88] transition-all duration-300 shadow-[0_0_15px_rgba(255,79,0,0.9)] relative"
              style={{ width: `${progress}%` }}
            >
              <div className="absolute top-0 right-0 bottom-0 w-3 bg-white/80 rounded-full blur-[1px]" />
            </div>
          </div>

          <div className="flex items-center justify-between text-[11px] font-mono">
            <span className="text-zinc-400 truncate">{statusText}</span>
            <span className="font-chakra font-black text-amber-400">{progress}%</span>
          </div>
        </div>

      </div>

      <style>{`
        @keyframes idgPulseGlow {
          0%, 100% {
            transform: translateY(0px) scale(1);
            filter: brightness(1);
          }
          50% {
            transform: translateY(-4px) scale(1.05);
            filter: brightness(1.3) drop-shadow(0 0 25px rgba(255, 79, 0, 0.9));
          }
        }
      `}</style>
    </div>
  );
}
